import React, { useState, useEffect } from 'react';
import { BackendURL } from '../utils/BackendURL';
import axios from 'axios';
import PuffLoader from "react-spinners/PuffLoader";
import LoginProtoPage from '../MyComponents/LoginProtoPage';
import { ToggleDarkMode } from '../assets/js/darkmode';
import { fetchCartProducts } from '../apis/cartApis';
import { useLoading } from '../assets/js/ContextProviders/LoadingContext';
import { fetchDataDB, handleSubmit, retrieveData } from '../apis/dataService';
import { useAccount } from '../assets/js/ContextProviders/AccountContext';
import DefaultImg from '../Images/Products/Default.png';
import CartCard from '../MyComponents/CartCard';

export default function Cart() {
    const { loading, startLoading, stopLoading } = useLoading();
    const { GetEmail, Account } = useAccount();

    // SHOW LOGINPROTOPAGE IF USER DIDN'T SIGNIN/LOGIN:
    const getLocalStorage = (name) => {
        const storedValue = localStorage.getItem(name);
        return storedValue ? JSON.parse(storedValue) : null;
    };
    useEffect(() => {
        const Username = getLocalStorage('UserName');
        const cartMain = document.getElementById('cart-main-id');
        const LoginProtoPageId = document.getElementById('LoginProtoPage-id');
        try {
            if (Username === null) {
                LoginProtoPageId.style.display = 'flex';
                cartMain.style.display = 'none';
            }
        } catch (error) {
            console.log('Error Occuered in loading the Account-Btn');
        }
    }, []);


    // FETCH DATA FROM DB AND SAVE IT IN setCartProducts:
    const [cartProducts, setCartProducts] = useState([]);
    const fetchData = async () => {
        startLoading();
        try {
            const products = await retrieveData({
                var: GetEmail(),
                api: '/cart'
            });
            const updatedOrders = products.map(({ Username, UserEmail, ...rest }) => rest);
            setCartProducts(updatedOrders);
            console.log("Cart PRODUCTS ", cartProducts)
            stopLoading();
        } catch (error) {
            console.error('Error fetching data:', error);
            stopLoading();
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    //TESTING:
    useEffect(() => {
        console.log(cartProducts)
    }, [cartProducts])

    // CALCULATE TOTAL:
    const [total, setTotal] = useState(0);
    useEffect(() => {
        const initialTotal = cartProducts.reduce((sum, item) => sum + (item.price * item.Quantity), 0);
        setTotal(initialTotal);
    }, [cartProducts]);

    const discount = 0;
    const shippingfee = 100;

    // SHOW PRODUCT LOGIC:
    const [showProduct, setShowProduct] = useState(false);

    const handleShowItemClick = () => {
        setShowProduct(!showProduct);
    };

    // INITAL INPUT VALUES:
    const [AccountInfo, setAccountInfo] = useState({
        userName: "LOGIN/SIGNUP",
        userEmail: "Not Provided",
        userAddress: "Not Provided",
        userPhone: "Not Provided",
        userPassword: "Not Provided",
        memberSince: "Not Provided"
    });

    const fetchAccountData = async () => {
        try {
            const AccountInfoResult = await retrieveData({
                var: GetEmail(),
                api: '/myaccount'
            });
            setAccountInfo(AccountInfoResult[0]);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        if (Account()) {
            fetchAccountData();
        }
    }, []);

    // FORM DATA:
    const [formData, setFormData] = useState({});
    useEffect(() => {
        setFormData({
            name: AccountInfo.userName || '',
            email: AccountInfo.userEmail || '',
            phone: AccountInfo.userPhone || '',
            address: AccountInfo.userAddress || ''
        });
    }, [AccountInfo]);

    function handleplaceorder() {
        const thanks = document.getElementById('thanksforbuying-id');
        if (cartProducts.length > 0) {
            startLoading();
            handleSubmit({
                mergedData: formData,
                h1: "TOTAL",
                data1: total,
                h2: "orders",
                data2: cartProducts,
                h3: "status",
                data3: "Placed",
                api: 'orders'
            }).then(function () {
                removecartProducts(GetEmail());
                thanks.style.display = 'flex';
                thanks.classList.add('show');

                // Remove the 'show' class after 2 seconds
                setTimeout(function () {
                    thanks.classList.remove('show');
                }, 2000);
            }).catch(function (error) {
                console.error('Error occurred during handleSubmit:', error);
            }).finally(function () {
                stopLoading();
            });
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // REMOVE CART PRODUCTS:
    async function removecartProducts(email) {
        try {
            const response = await axios.delete(`${BackendURL}/removecart/${email}`);
            setCartProducts([]);
            console.log('Cart products deleted successfully:', response.data);
        } catch (error) {
            console.error('Error deleting cart products:', error);
        }
    }

    return (
        <>
            <LoginProtoPage />
            <div className='cart-main' id='cart-main-id'>
                <div className="billingform">
                    <div className="cart-total">
                        <h1 className="cart-total-h1">
                            Order Summary:
                        </h1>
                        <div className="parent-cart-summary">
                            <div className="parent-smmary">
                                <div className="cart-total-divs">
                                    <div>
                                        Subtotal
                                    </div>
                                    <div>
                                        {total}
                                    </div>
                                </div>
                                <div className="cart-total-divs">
                                    <div> Shipping Fee </div>
                                    <div>{shippingfee} </div>
                                </div>
                                <div className="cart-total-divs">
                                    <div> Discount </div>
                                    <div> {discount} </div>
                                </div>
                                <div className="cart-total-divs">
                                    <div> Total  </div>
                                    <div> {total + shippingfee} </div>
                                </div>
                            </div>
                            <div className="parent-input-summary">
                                <form>
                                    <label htmlFor="name">Name:</label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                    <label htmlFor="email">Email:</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                    <label htmlFor="phone">Phone Number:</label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />
                                    <label htmlFor="address">Shipping Address:</label>
                                    <input
                                        type="text"
                                        id="address"
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                        required
                                    />
                                </form>
                            </div>
                        </div>
                        <div className="placeorder" onClick={handleplaceorder}>
                            <button>
                                PLACE ORDER
                            </button>
                        </div>
                    </div>
                    <div className="showproducts" onClick={handleShowItemClick}>
                        <span>Show Items</span>
                        <div>
                            <i className="fas fa-chevron-down"></i>
                        </div>
                    </div>

                    {/* If cart is empty and showProduct is true */}
                    {showProduct && cartProducts.length === 0 && (
                        <div className="no-cart-items">
                            No item added in the cart
                        </div>
                    )}

                    {/* If cart has products and showProduct is true */}
                    <div
                        className="parent-cart-products"
                        style={{ display: showProduct && cartProducts.length > 0 ? 'flex' : 'none' }}
                    >
                        {cartProducts.map((item, index) => (
                            <CartCard
                                name={item.name}
                                price={item.price}
                                description={item.description}
                                key={index}
                                index={index}
                                productId={item._id}
                                quantity={item.Quantity}
                                fetchData={fetchData}
                            />
                        ))}
                    </div>

                    <div className="thanksforbuying" id='thanksforbuying-id'>
                        <p>
                            "Thank you for your purchase! We appreciate your trust in us."
                        </p>
                    </div>
                </div>
            </div >
        </>
    );
}
